import authorized from "@/middleware/authorized"
import paid from "@/middleware/paid"
import PlanningGeneral from "@/components/pages/planning/PlanningGeneral"

export default {
    path: '/planning',
    meta: { middleware: [authorized, paid], layout: "default", rights: ['call_planning'] },
    component: PlanningGeneral,
    children: [
        { path: '', redirect: '/planning/calls' },
        {
            path: 'calls', name: "CallPlanning",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['call_planning'] },
            component: () => import('../components/pages/planning/CallPlanning.vue')
        },
        {
            path: 'visits', name: "CallVisits",
            meta: { middleware: [authorized, paid], layout: "default", rights: ['call_planning'] },
            component: () => import('../components/pages/planning/CallVisits.vue')
        },
    ]

}
